import Label from '../../Utils/FormInputs/Label';
import TextField from '../../Utils/FormInputs/TextField';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles(() => ({
  root: {
    padding: '8px 0',
    borderBottom: '1px solid #f0f0f0',
    alignItems: 'center',
  },
  timestamp: {
    fontSize: '0.8rem',
    color: '#666',
    fontWeight: 500,
  },
  input: {
    '& input': {
      padding: '8px 10px',
      fontSize: '0.85rem',
    },
  },
}));

/**
 * Reusable vitals entry row for PACU vitals, intra-op vitals,
 * day-case observation vitals, and anaesthesia records
 */
const VitalsRow = ({
  timestamp,
  systolic = '',
  diastolic = '',
  heartRate = '',
  spo2 = '',
  temperature = '',
  respiratoryRate = '',
  onChange,
  onDelete,
  disabled = false,
  showDelete = true,
}) => {
  const classes = useStyles();

  const handleFieldChange = (field) => (e) => {
    if (onChange) {
      onChange(field, e.target.value);
    }
  };

  return (
    <Grid container spacing={1} className={classes.root}>
      <Grid item xs={2}>
        <Typography className={classes.timestamp}>{timestamp}</Typography>
      </Grid>
      <Grid item xs={2}>
        <TextField
          className={classes.input}
          variant="outlined"
          size="small"
          placeholder="Sys/Dia"
          value={systolic && diastolic ? `${systolic}/${diastolic}` : systolic || ''}
          onChange={handleFieldChange('bp')}
          disabled={disabled}
          fullWidth
        />
      </Grid>
      <Grid item xs={1}>
        <TextField
          className={classes.input}
          variant="outlined"
          size="small"
          placeholder="HR"
          value={heartRate}
          onChange={handleFieldChange('heartRate')}
          disabled={disabled}
          fullWidth
          type="number"
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          className={classes.input}
          variant="outlined"
          size="small"
          placeholder="SpO2 %"
          value={spo2}
          onChange={handleFieldChange('spo2')}
          disabled={disabled}
          fullWidth
          type="number"
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          className={classes.input}
          variant="outlined"
          size="small"
          placeholder="Temp °C"
          value={temperature}
          onChange={handleFieldChange('temperature')}
          disabled={disabled}
          fullWidth
          type="number"
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          className={classes.input}
          variant="outlined"
          size="small"
          placeholder="RR"
          value={respiratoryRate}
          onChange={handleFieldChange('respiratoryRate')}
          disabled={disabled}
          fullWidth
          type="number"
        />
      </Grid>
      {showDelete && (
        <Grid item xs={1}>
          <IconButton size="small" onClick={onDelete} disabled={disabled}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
};

export default VitalsRow;
